// Central brand/site configuration — the single source of truth for the site identity.
// Values come from frontend/.env (REACT_APP_SITE_*). Changing the brand
// (e.g. rebranding the site) is an .env edit, not a code change.
export const SITE = {
  name: process.env.REACT_APP_SITE_NAME,                 // TravelerPulse
  brandDomain: process.env.REACT_APP_SITE_BRAND_DOMAIN,  // TravelerPulse.pro
  brandLabel: `${process.env.REACT_APP_SITE_BRAND_DOMAIN}™`,
  domain: process.env.REACT_APP_SITE_DOMAIN,             // travelerpulse.pro
  url: process.env.REACT_APP_SITE_URL,                   // https://travelerpulse.pro
  tagline: process.env.REACT_APP_SITE_TAGLINE,
  supportEmail: process.env.REACT_APP_SUPPORT_EMAIL,
};
